import { useCreatedEvent, useDeletedEvent, useGameContext } from "../../../core/game/client/useGameContext";
import { ReplicatedObjectEvent } from "../../../core/game/common/ReplicatedObjectView";
import { ReplicatedObject } from "../../../core/game/interfaces/ReplicatedObject";
import { createReplicatedLock } from "../../../core/game/server/ReplicatedLock";
import { WriteableReplicatedObject } from "../../../core/game/server/WriterContext";
import { getComplexAnnouncementBannerTime, getDeniedBannerFinishTime } from "../../../front/core/util/BannerTimelineConstants";
import { Contact3DLock } from "../Contact3DLock";
import { createAnswerResultTimeout } from "../replicatedTimeouts/AnswerResultTimeout";
import { createCommitAnswerTimeout } from "../replicatedTimeouts/CommitAnswerTimeout";
;
export const ClueViewFn = (oldData, newData, context) => {
    let areHintsEqual = true;
    if (oldData !== null) {
        if (oldData.hints.length !== newData.hints.length) {
            areHintsEqual = false;
        }
        for (let i = 0; i < oldData.hints.length; i += 1) {
            if (oldData.hints[i] !== newData.hints[i]) {
                areHintsEqual = false;
            }
        }
    }
    return Object.assign(Object.assign({}, newData), { clueContactEvent: new ReplicatedObjectEvent((oldData === null || oldData.submittedAnswer === undefined) && newData.submittedAnswer !== undefined), clueDeniedEvent: new ReplicatedObjectEvent((oldData === null || oldData.denied === undefined) && newData.denied !== undefined), additionalHintEvent: new ReplicatedObjectEvent(!areHintsEqual) });
};
export class WriteableClue extends WriteableReplicatedObject {
    transformDataToCommit(dataInput) {
        if (this.isInitialData(dataInput)) {
            return this.sliceHints(dataInput.initialData);
        }
        return Object.assign(Object.assign({}, dataInput.previousData), this.sliceHints(dataInput.partialData));
    }
    sliceHints(partialData) {
        if (partialData.hints !== undefined && partialData.hints.length > 3) {
            partialData.hints = partialData.hints.slice(-3);
        }
        return partialData;
    }
    beforeCommitData(partialData) {
        const submittedAnswer = partialData.submittedAnswer;
        if (submittedAnswer !== undefined) {
            const time = this.context.gameState.data.currentContactTime * 1000;
            this.commitAnswerTimeout = createCommitAnswerTimeout(Object.assign({ clueId: this.data.id, durationMs: time }, submittedAnswer), this.context);
        }
    }
    commitAnswerImmediate(answer, sourceId, sourceUsername) {
        const answerWasCorrect = this.data.clueAnswer === answer;
        const answeredBySecretWordGiver = sourceId === this.context.gameState.data.secretWordGiverId;
        const isGameOver = (!answeredBySecretWordGiver && this.data.clueAnswer === this.context.gameState.data.secretWord) || answer === this.context.gameState.data.secretWord
            || answerWasCorrect && !answeredBySecretWordGiver && this.context.gameState.data.isOnPenultimateLetter;
        if (answeredBySecretWordGiver && (isGameOver || answerWasCorrect)) {
            if (this.commitAnswerTimeout !== undefined) {
                this.commitAnswerTimeout.cancel();
                this.commitAnswerTimeout = undefined;
            }
        }
        if (answeredBySecretWordGiver && !answerWasCorrect && answer !== this.context.gameState.data.secretWord) {
            this.context.gameState.addPreviousClue(answer);
            this.context.gameState.commitNewGuess(sourceId, sourceUsername, answer);
        }
        else {
            if (answeredBySecretWordGiver && (answerWasCorrect || answer === this.context.gameState.data.secretWord)) {
                this.commitData({
                    denied: {
                        secretWordGiverUsername: this.context.players.data.getPlayerUsername(this.context.gameState.data.secretWordGiverId),
                        secretWordGiverAnswer: answer,
                    }
                });
            }
            const durationMs = answeredBySecretWordGiver && this.data.submittedAnswer !== undefined ? getDeniedBannerFinishTime() : getComplexAnnouncementBannerTime();
            createReplicatedLock({
                key: Contact3DLock.AnswerSubmissionLock, durationMs
            }, this.context);
            createAnswerResultTimeout({
                clueId: this.data.id,
                answer,
                sourceId,
                sourceUsername,
                answeredBySecretWordGiver,
                answerWasCorrect,
                isGameOver,
                durationMs,
            }, this.context);
        }
    }
}
export const Clue = new ReplicatedObject('Clue', [{ optional: 'clue' }], WriteableClue, (input, data) => {
    return 'clue';
}, ClueViewFn);
export function useClue() {
    return useGameContext('clue');
}
export function useClueCreatedEvent() {
    return useCreatedEvent('clue');
}
export function useClueDeletedEvent() {
    return useDeletedEvent('clue');
}
//# sourceMappingURL=Clue.js.map